import { StepReventionsHow } from "../../data";

const Reventions = () =>{
    return(
        <div className="flex flex-col sm:grid sm:grid-cols-2 p-2 sm:px-12 sm:mx-24 my-12">
            <div className="col-span-1 text-gray-800 m-1 mb-4 sm:mt-16 sm:ml-20">
                <h3 className=" font-semibold mr-4 text-4xl sm:text-5xl mb-4">¿Cómo se aplica Renovación Total en arriendo?</h3>
                <div className="h-4 w-40 bg-gray-800 mb-2 sm:mb-10"></div>
                <p className="text-gray-700 text-lg mr-16 sm:mr-28">
                En el caso de los <b>arriendos</b>, una vez
                aprobado el presupuesto de los
                trabajos a realizar:
                </p>
            </div>
            <div className="sm:col-span-1">
                <ul className="flex flex-col items-center gap-4">
                    {StepReventionsHow.length > 0 ? StepReventionsHow.map(item => (
                        <li
                            key={item.id}
                            className="bg-gray-600 text-gray-50 flex flex-row items-center gap-2 rounded-sm w-96 sm:w-80 h-20 py-4 px-2 sm:p-2 sm:px-6 hover:scale-105 duration-150">
                            <h4 className="text-xl font-bold w-16">{item.number}</h4>
                            <p className="sm:mr-1 text-xl sm:text-base">{item.desc}</p>
                        </li>
                    )):''}
                  
                </ul>
            </div>
        </div>
    )
}
export default Reventions;